import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";


export const VaultEmptyStateWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 32px 0px;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    color: var(--Dark-Gray-1, #1A1B1D);
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;

    ${({ isMobile }) => isMobile && `
        justify-content: center;
    `}
`;

export const VaultIconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const VaultEmptyStateHeader = styled.div`
    display: flex;
    width: 100%;
    height: 8px;
    padding: 8px 4px 8px 8px;
    align-items: center;
    gap: 8px;

    border-bottom: 1px solid #F1F3F5;
`;

export const VaultEmptyStateTitleText = styled.div`
    font-weight: 700;
`;

export const VaultEmptyStateButton = styled.div`
    display: flex;
    height: 40px;
    padding: 0px 24px;
    align-items: center;
    gap: 6px;

    border-radius: 10px;
    background: ${colors.darkGray1};

    color: #fff;
    cursor: pointer;

    &:hover {
        background: var(--Main-Colors-Dark-Grey-2, #2B2C2E);
    }
`;